module.exports = __webpack_public_path__ + "img/arrow.32144429.png";